import React from 'react';
import { Button, notification } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const CustomBtn = styled(Button)`
    border: none !important;
`;

const copyString = async (value: string) => {
    if (value && navigator) {
        await navigator.clipboard.writeText(value);
        notification.success({
            message: undefined,
            description: "Copied Successfully",
            placement: "bottomLeft",
        });
    }
};

export const AssetCopyButton: React.FC<{ value: any }> = ({ value }) => {
    return value?.length ? (
        <span>
            <CustomBtn
                style={{ cursor: "pointer" }}
                title="Copy"
                icon={<CopyOutlined />}
                type={"link"}
                onClick={e => {
                    e.stopPropagation();
                    copyString(value);
                }}
            />
            {value}
        </span>
    ) : (
        <></>
    );
};